import { supabase } from './supabase';
import { STORAGE_CONFIG } from '../constants/storageConstants';

export const storageService = {
  async ensureBucket() {
    try {
      // Check if bucket exists
      const { data: buckets } = await supabase.storage.listBuckets();
      const bucketExists = buckets?.some(b => b.name === STORAGE_CONFIG.BUCKET_NAME);
      
      if (!bucketExists) {
        // Create the bucket if it doesn't exist
        const { data, error } = await supabase.storage.createBucket(STORAGE_CONFIG.BUCKET_NAME, {
          public: true,
          fileSizeLimit: STORAGE_CONFIG.MAX_FILE_SIZE
        });

        if (error) throw error;
        // Note: RLS policies must be set via SQL migrations, not via JS client
      }
    } catch (error) {
      console.error('Error ensuring bucket exists:', error);
      throw error;
    }
  },

  async uploadFile(file, path) {
    try {
      // Ensure bucket exists before upload
      await this.ensureBucket();
      
      const { data, error } = await supabase.storage
        .from(STORAGE_CONFIG.BUCKET_NAME)
        .upload(path, file, {
          cacheControl: '3600',
          upsert: true
        });

      if (error) throw error;

      // Get public URL
      const { data: { publicUrl } } = supabase.storage
        .from('assets')
        .getPublicUrl(path);

      return { data, publicUrl };
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },

  async deleteFile(path) {
    try {
      const { data, error } = await supabase.storage
        .from('assets')
        .remove([path]);

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  }
};
